module.exports = __webpack_public_path__ + "static/media/tb_app_icon_primary_user.8725069d.svg";